import { ref, uploadBytes, getDownloadURL, getStorage } from 'firebase/storage';
import { storage } from '../firebase/config';

// Upload profile picture and get download URL
export const uploadProfilePicture = async (userId: string, file: File): Promise<string> => {
  try {
    // Create storage reference
    const storageRef = ref(storage, `profile_pictures/${userId}`);
    
    // Upload file
    await uploadBytes(storageRef, file);
    
    // Get download URL
    const downloadURL = await getDownloadURL(storageRef);
    
    return downloadURL;
  } catch (error) {
    console.error("Error uploading profile picture:", error);
    throw error;
  }
};

export const uploadBusinessLogo = async (businessId: string, file: File): Promise<string> => {
  const storage = getStorage();
  const storageRef = ref(storage, `business_logos/${businessId}`);
  
  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);
  
  return downloadURL;
};


export const uploadUserPhoto = async (userId: string, file: File): Promise<string> => {
  try {
    const storageRef = ref(storage, `profile_pictures/${userId}`);
    const snapshot = await uploadBytes(storageRef, file);
    return await getDownloadURL(snapshot.ref);
  } catch (error) {
    console.error('Error uploading user photo:', error);
    throw error;
  }
};